"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const is_missing_1 = require("../any/is-missing");
/*
 * Recursively digs in the given object with the given keys.
 *
 * @Param {Object} object    = The object to dig in.
 * @Param (...String) keys   = The keys to dig with.
 *
 * @Example
 *
 *   const dishes = { dishes: { good: { italian: 'Pizza' } } };
 *   dig(dishes, 'dishes', 'good', 'italian')
 *   //=> 'Pizza'
 */
function dig(object, ...keys) {
    return keys.reduce((acc, key) => {
        if (is_missing_1.isMissing(acc)) {
            return acc;
        }
        const value = acc[key];
        return value;
    }, object);
}
exports.dig = dig;
//# sourceMappingURL=dig.js.map